module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap"
  }, [_c('Loading', {
    attrs: {
      "show": _vm.loading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "inline-block"
  }, [_c('label', [_vm._v("Datumfält")]), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "options": _vm.propertyValues,
      "valuebinder": _vm.property,
      "label": "Datumvärde",
      "validated": false,
      "show-label-subtitle": false
    },
    on: {
      "update:valuebinder": function($event) {
        _vm.property = $event
      },
      "changed": function($event) {
        return _vm.fetch()
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "inline-block"
  }, [_c('label', [_vm._v("Period")]), _vm._v(" "), _c('Dropdown', {
    ref: "dateDropdown",
    attrs: {
      "prefixicon": "calendar",
      "prefixicon-validated": "calendar-white",
      "tabindex": "0",
      "options": [],
      "validated": false,
      "label": '' + _vm.formatDate(_vm.pickedStartDate) + '',
      "bold-label": false
    },
    on: {
      "clicked": _vm.datepickerRangeModal,
      "clicked-suffix": _vm.dateClear
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "inline-block"
  }, [_c('label', [_vm._v("Betalda")]), _vm._v(" "), _vm._l((_vm.payedYesno), function(option) {
    return _c('button', {
      class: {
        button: true,
          underlined: true,
          'small-text': true,
          small: true,
          checked: (_vm.selectedPayed[option.value]),
      },
      on: {
        "click": function($event) {
          return _vm.toggledPayed(option.value)
        }
      }
    }, [_vm._v("\n      " + _vm._s(option.title) + "\n    ")])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "inline-block"
  }, [_c('label', [_vm._v("Betalmetod")]), _vm._v(" "), _vm._l((_vm.payTypes), function(option) {
    return _c('button', {
      class: {
        button: true,
          underlined: true,
          'small-text': true,
          small: true,
          checked: (_vm.selectedPayTypes[option.value]),
      },
      on: {
        "click": function($event) {
          return _vm.togglePayType(option.value)
        }
      }
    }, [_vm._v("\n      " + _vm._s(option.title) + "\n    ")])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "inline-block"
  }, [_c('label', [_vm._v("Betalmetod mobilhyra")]), _vm._v(" "), _vm._l((_vm.subPayTypes), function(option) {
    return _c('button', {
      class: {
        button: true,
          underlined: true,
          'small-text': true,
          small: true,
          checked: (_vm.selectedSubPayTypes[option.value]),
      },
      on: {
        "click": function($event) {
          return _vm.toggleSubPayType(option.value)
        }
      }
    }, [_vm._v("\n      " + _vm._s(option.title) + "\n    ")])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "inline-block"
  }, [_c('label', [_vm._v("Orderkälla")]), _vm._v(" "), _vm._l((_vm.orderSources), function(option) {
    return _c('button', {
      class: {
        button: true,
          underlined: true,
          'small-text': true,
          small: true,
          checked: (_vm.selectedOrderSources[option.value]),
      },
      on: {
        "click": function($event) {
          return _vm.toggleOrderSource(option.value)
        }
      }
    }, [_vm._v("\n      " + _vm._s(option.title) + "\n    ")])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "inline-block"
  }, [_c('label', [_vm._v("Resultat")]), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "options": _vm.perPageOptions,
      "valuebinder": _vm.perPage,
      "label": "Per sida",
      "validated": false,
      "show-label-subtitle": false
    },
    on: {
      "update:valuebinder": function($event) {
        _vm.perPage = $event
      },
      "changed": function($event) {
        return _vm.fetch()
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "inline-block"
  }, [_c('label', [_vm._v("Vy")]), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "options": _vm.groupOptions,
      "valuebinder": _vm.groupBy,
      "label": "Vy",
      "validated": false,
      "show-label-subtitle": false
    },
    on: {
      "update:valuebinder": function($event) {
        _vm.groupBy = $event
      },
      "changed": function($event) {
        return _vm.fetch()
      }
    }
  })], 1), _vm._v(" "), (this.groupBy === 'line') ? _c('div', {
    staticClass: "inline-block"
  }, [_c('label', [_vm._v("Ordertyp")]), _vm._v(" "), _vm._l((_vm.types), function(option) {
    return (_vm.SITE_CONFIG.modules[option.module]) ? _c('button', {
      class: {
        button: true,
          underlined: true,
          'small-text': true,
          small: true,
          checked: (_vm.selectedTypes[option.value]),
      },
      on: {
        "click": function($event) {
          return _vm.toggleType(option.value)
        }
      }
    }, [_vm._v("\n      " + _vm._s(option.title) + "\n    ")]) : _vm._e()
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "inline-block"
  }, [_c('label', [_vm._v(" ")]), _vm._v(" "), _c('button', {
    staticClass: "white border",
    on: {
      "click": function($event) {
        return _vm.fetch()
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "Reset",
      "scale": 2
    }
  })], 1)]), _vm._v(" "), (_vm.showDirectSearch) ? _c('div', {
    staticClass: "inline-block"
  }, [_c('label', [_vm._v("Direktsök")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchQuery),
      expression: "searchQuery"
    }],
    staticClass: "short",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.searchQuery)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.doSearch()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "inline-block"
  }, [_c('label', [_vm._v("Gäst")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchQueryName),
      expression: "searchQueryName"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.searchQueryName)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.fetch()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchQueryName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', [_vm._v("\n    Visar: "), _c('b', [_vm._v(_vm._s(_vm.from))]), _vm._v("-"), _c('b', [_vm._v(_vm._s(_vm.to))]), _vm._v(" av "), _c('b', [_vm._v(_vm._s(_vm.total))]), _vm._v("\n         \n    Sida:\n    "), _vm._l((_vm.pages), function(p) {
    return _c('div', {
      class: 'button small border ' + ((p == _vm.page) ? '' : 'white'),
      on: {
        "click": function($event) {
          return _vm.changePage(p)
        }
      }
    }, [_vm._v(_vm._s(p))])
  })], 2), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "href": _vm.getExcelReportLink
    }
  }, [_vm._v("Exportera som Excel")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("#")]), _vm._v(" "), _c('th', {
    class: {
      active: (_vm.sortKey == 'created_at')
    },
    on: {
      "click": function($event) {
        return _vm.setSortBy('created_at')
      }
    }
  }, [_vm._v("Skapad")]), _vm._v(" "), (_vm.groupBy === 'line') ? _c('th', {
    class: {
      active: (_vm.sortKey == 'pretty_type')
    },
    on: {
      "click": function($event) {
        return _vm.setSortBy('pretty_type')
      }
    }
  }, [_vm._v("Typ")]) : _vm._e(), _vm._v(" "), (_vm.groupBy === 'line') ? _c('th', {
    class: {
      active: (_vm.sortKey == 'person_name')
    },
    on: {
      "click": function($event) {
        return _vm.setSortBy('person_name')
      }
    }
  }, [_vm._v("Namn")]) : _vm._e(), _vm._v(" "), _c('th', {
    class: {
      active: (_vm.sortKey == 'arrival')
    },
    on: {
      "click": function($event) {
        return _vm.setSortBy('arrival')
      }
    }
  }, [_vm._v("Från")]), _vm._v(" "), _c('th', {
    class: {
      active: (_vm.sortKey == 'departure')
    },
    on: {
      "click": function($event) {
        return _vm.setSortBy('departure')
      }
    }
  }, [_vm._v("Till")]), _vm._v(" "), _c('th', {
    class: {
      active: (_vm.sortKey == 'has_error')
    },
    on: {
      "click": function($event) {
        return _vm.setSortBy('has_error')
      }
    }
  }, [_vm._v("Fel")]), _vm._v(" "), _c('th', {
    class: {
      active: (_vm.sortKey == 'status')
    },
    on: {
      "click": function($event) {
        return _vm.setSortBy('status')
      }
    }
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', {
    class: {
      active: (_vm.sortKey == 'line_sum')
    },
    on: {
      "click": function($event) {
        return _vm.setSortBy('line_sum')
      }
    }
  }, [_vm._v("Summa")]), _vm._v(" "), (_vm.groupBy === 'head') ? _c('th', {
    class: {
      active: (_vm.sortKey == 'line_sum_skirental')
    },
    on: {
      "click": function($event) {
        return _vm.setSortBy('line_sum_skirental')
      }
    }
  }, [_vm._v("Hyra")]) : _vm._e(), _vm._v(" "), (_vm.groupBy === 'head') ? _c('th', {
    class: {
      active: (_vm.sortKey == 'line_sum_skischool')
    },
    on: {
      "click": function($event) {
        return _vm.setSortBy('line_sum_skischool')
      }
    }
  }, [_vm._v("Skola")]) : _vm._e(), _vm._v(" "), _c('th', {
    class: {
      active: (_vm.sortKey == 'pretty_klarna_status')
    },
    on: {
      "click": function($event) {
        return _vm.setSortBy('pretty_klarna_status')
      }
    }
  }, [_vm._v("Betalstatus")]), _vm._v(" "), _c('th', {
    class: {
      active: (_vm.sortKey == 'number')
    },
    on: {
      "click": function($event) {
        return _vm.setSortBy('number')
      }
    }
  }, [_vm._v("Ordernr.")]), _vm._v(" "), _c('th', {
    class: {
      active: (_vm.sortKey == 'order_source')
    },
    on: {
      "click": function($event) {
        return _vm.setSortBy('order_source')
      }
    }
  }, [_vm._v("Källa")]), _vm._v(" "), _c('th', {
    class: {
      active: (_vm.sortKey == 'payment_method')
    },
    on: {
      "click": function($event) {
        return _vm.setSortBy('payment_method')
      }
    }
  }, [_vm._v("Betalmetod")]), _vm._v(" "), _c('th', {
    class: {
      active: (_vm.sortKey == 'sub_payment_method')
    },
    on: {
      "click": function($event) {
        return _vm.setSortBy('sub_payment_method')
      }
    }
  }, [_vm._v("Hyra")]), _vm._v(" "), _c('th', {
    class: {
      active: (_vm.sortKey == 'synced_with_r360')
    },
    on: {
      "click": function($event) {
        return _vm.setSortBy('synced_with_r360')
      }
    }
  }, [_vm._v("Synkad "), (_vm.SITE_CONFIG.site === 'branas' || _vm.SITE_CONFIG.site === 'kungsberget') ? _c('span', [_vm._v("360")]) : _c('span', [_vm._v("Skibar")])]), _vm._v(" "), (_vm.SITE_CONFIG.site !== 'vallasen' && _vm.SITE_CONFIG.site !== 'ulricehamn') ? _c('th', {
    class: {
      active: (_vm.sortKey == 'status_customer_set')
    },
    on: {
      "click": function($event) {
        return _vm.setSortBy('status_customer_set')
      }
    }
  }, [_vm._v("Kund")]) : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.site !== 'vallasen' && _vm.SITE_CONFIG.site !== 'ulricehamn') ? _c('th', {
    class: {
      active: (_vm.sortKey == 'status_fully_payed')
    },
    on: {
      "click": function($event) {
        return _vm.setSortBy('status_fully_payed')
      }
    }
  }, [_vm._v("Bet")]) : _vm._e()])]), _vm._v(" "), _c('tbody', _vm._l(((_vm.reverse ? _vm.orderBy(_vm.data, _vm.sortKey).reverse() : _vm.orderBy(_vm.data, _vm.sortKey))), function(order, index) {
    return _c('tr', {
      class: {
        warning: (order.pretty_status_simple < 4),
          error: (!order.number || order.has_error || order.error_code || !order.synced_with_r360),
          active: order.active,
          dimmed: (order.pretty_status_simple < 9 && order.order_source === 'web'),
          okay: (order.pretty_status_simple >= 9),
          notpayed: (_vm.SITE_CONFIG.site !== 'vallasen' && _vm.SITE_CONFIG.site !== 'ulricehamn' && !order.status_fully_payed && order.order_source === 'web'),
          customernotset: (_vm.SITE_CONFIG.site !== 'vallasen' && _vm.SITE_CONFIG.site !== 'ulricehamn' && !order.status_customer_set && order.order_source === 'web'),
          canceled: order.canceled
      },
      on: {
        "click": function($event) {
          return _vm.openOrder(order, index)
        }
      }
    }, [_c('td', [_vm._v(_vm._s(order.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("date")(order.created_at, 'short-with-time')))]), _vm._v(" "), (_vm.groupBy === 'line') ? _c('td', [_vm._v(_vm._s(order.pretty_type))]) : _vm._e(), _vm._v(" "), (_vm.groupBy === 'line') ? _c('td', [_vm._v(_vm._s(order.person_name))]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(order.arrival))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(order.departure))]), _vm._v(" "), _c('td', {
      class: {
        mark: order.error_code
      }
    }, [_vm._v(_vm._s(order.error_code))]), _vm._v(" "), _c('td', {
      class: {
        mark: order.pretty_status_simple < 4
      }
    }, [_vm._v(_vm._s(order.pretty_status))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("currency")(order.line_sum, {
      symbol: false
    })))]), _vm._v(" "), (_vm.groupBy === 'head') ? _c('td', [_vm._v(_vm._s(_vm._f("currency")(order.line_sum_skirental, {
      symbol: false
    })))]) : _vm._e(), _vm._v(" "), (_vm.groupBy === 'head') ? _c('td', [_vm._v(_vm._s(_vm._f("currency")(order.line_sum_skischool, {
      symbol: false
    })))]) : _vm._e(), _vm._v(" "), _c('td', {
      class: {
        mark: order.status === 'checkout_complete'
      }
    }, [_vm._v(_vm._s(order.pretty_klarna_status))]), _vm._v(" "), _c('td', {
      class: {
        mark: !order.number
      }
    }, [_vm._v(_vm._s(order.number))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(order.order_source))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(order.payment_method))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(order.sub_payment_method))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(order.synced_with_r360 ? 'Ja' : 'NEJ'))]), _vm._v(" "), (_vm.SITE_CONFIG.site !== 'vallasen' && _vm.SITE_CONFIG.site !== 'ulricehamn') ? _c('td', [_vm._v(_vm._s(order.status_customer_set ? 'Ja' : (order.source === 'web' ? 'NEJ' : '-')))]) : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.site !== 'vallasen' && _vm.SITE_CONFIG.site !== 'ulricehamn') ? _c('td', [_vm._v(_vm._s(order.status_fully_payed ? 'Ja' : (order.source === 'web' ? 'NEJ' : '-')))]) : _vm._e()])
  }), 0), _vm._v(" "), _c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th'), _vm._v(" "), (_vm.groupBy === 'line') ? _c('th') : _vm._e(), _vm._v(" "), (_vm.groupBy === 'line') ? _c('th') : _vm._e(), _vm._v(" "), _c('th'), _vm._v(" "), _c('th'), _vm._v(" "), _c('th'), _vm._v(" "), _c('th'), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm._f("currency")(_vm.sum)))]), _vm._v(" "), (_vm.groupBy === 'head') ? _c('th', [_vm._v(_vm._s(_vm._f("currency")(_vm.sumSkirental)))]) : _vm._e(), _vm._v(" "), (_vm.groupBy === 'head') ? _c('th', [_vm._v(_vm._s(_vm._f("currency")(_vm.sumSkischool)))]) : _vm._e(), _vm._v(" "), _c('th'), _vm._v(" "), _c('th'), _vm._v(" "), _c('th'), _vm._v(" "), _c('th'), _vm._v(" "), _c('th')])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', [_vm._v("\n    Sida:\n    "), _vm._l((_vm.pages), function(p) {
    return _c('div', {
      class: 'button small border ' + ((p == _vm.page) ? '' : 'white'),
      on: {
        "click": function($event) {
          return _vm.changePage(p)
        }
      }
    }, [_vm._v(_vm._s(p))])
  })], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('router-view', {
    key: _vm.$route.params.orderId
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5b589f1d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/OrderList.vue
// module id = 980
// module chunks = 0